import React from "react";

import ZooMap from "../components/ZooMap";

const MainComponent = () => {
 

  return <ZooMap  />;
};

export default MainComponent;
